import { IUser } from '@bridebook/models/source/models/Weddings/Users.types';
import { AccessControlActionTypes } from '@bridebook/web/lib/access-control/action-types';
import type { IDeps, TWeddingSerialized } from '@bridebook/web/lib/types';
import { updateWedding } from '@bridebook/web/lib/weddings/actions';

export const onAccessControlListener = (acl: Record<string, IUser>) => ({
  type: AccessControlActionTypes.ON_ACCESS_CONTROL_LISTENER,
  payload: acl,
});

export const updateAccessControlSuccess =
  (activeWedding: TWeddingSerialized) =>
  ({ dispatch }: IDeps) => {
    dispatch(updateWedding(activeWedding));
    return {
      type: AccessControlActionTypes.UPDATE_ACCESS_CONTROL_SUCCESS,
    };
  };
